import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

const SeasonOverviewReportPropertySummaryGraph = (props) => {
  if (!props.trappingZonehotTrapStatuses) return null;

  const totalCatch = props.trappingZonehotTrapStatuses.reduce((prev, curr) => {
    return prev + curr.trap.catch;
  }, 0);
  const averageCatch = totalCatch / props.trappingZonehotTrapStatuses.length;

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={{
        chart: {
          type: 'column',
          height: 447
        },
        credits: {
          enabled: false
        },
        title: {
          text: 'Site Trap Totals'
        },
        xAxis: {
          categories: props.trappingZonehotTrapStatuses.map(
            (tzhts) => `${tzhts.trap.name} (${tzhts.trap.code})`
          )
        },
        yAxis: {
          title: {
            text: 'Trap Catch'
          },
          min: 0,
          minRange: 1,
          tickInterval: 1,
          plotLines: [
            {
              color: '#c2c2c2',
              value: averageCatch,
              dashStyle: 'dash',
              width: 2
            }
          ]
        },
        legend: {
          enabled: true,
          symbolRadius: 0
        },
        tooltip: {
          formatter: function () {
            const trapID = {
              code: this.key.match(/(.+) \((.+)\)/)[2],
              name: this.key.match(/(.+) \((.+)\)/)[1]
            };
            const trap = props.trappingZonehotTrapStatuses.find(
              (tzhts) =>
                tzhts.trap.code === trapID.code &&
                tzhts.trap.name === trapID.name
            )?.trap;
            return (
              '<b>' +
              this.key +
              '</b>' +
              '<br/>' +
              'Name: ' +
              trap.name +
              '<br/>' +
              'Location: ' +
              trap.location_description +
              '<br/>' +
              'Total: ' +
              trap.catch +
              '<br/>' +
              'Average: ' +
              averageCatch.toFixed(1)
            );
          }
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
            centerInCategory: true
          }
        },
        series: [
          {
            name: 'Catch',
            data: props.trappingZonehotTrapStatuses.map((tzhts) => {
              return tzhts.trap.catch;
            }),
            events: {
              legendItemClick: function () {
                return false;
              }
            }
          },
          {
            type: 'line',
            name: 'Average',
            dashStyle: 'Dash',
            color: '#c2c2c2',
            marker: {
              enabled: false,
              states: {
                hover: {
                  enabled: false
                }
              }
            },
            data: [],
            events: {
              legendItemClick: function () {
                return false;
              }
            }
          }
        ]
      }}
    />
  );
};

SeasonOverviewReportPropertySummaryGraph.propTypes = {
  trappingZonehotTrapStatuses: PropTypes.array
};

export default observer(SeasonOverviewReportPropertySummaryGraph);
